import { OwnerDonorReportOutput } from 'gql/types';

export const formatOwnerDonors = (
  donors?: OwnerDonorReportOutput[] | null
): string => {
  if (!donors?.length) {
    return '';
  }

  return donors.map(({ name, status }) => `${name}__${status}`).join(', ');
};
